<template>
    <div class="module">
        <helpinfo :helpData="helpData" />
        <div class="module-container">
            <rcTable ref="rcTable"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
            </rcTable>
        </div>
    </div>
</template>
<script>
import helpinfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
export default {
    name: 'snapshot',
    components: {
        rcTable,
        helpinfo
    },
    data () {
        const isBssAdmin = this.$store.state.user.currentUser.isBssAdmin
        return {
            helpData: {
                modelName: this.$t('NAT网关'),
                showBack: false
            },
            tableAttr: {
                source: {
                    type: 'staticData', // 'staticData'静态数据
                    tableData: {
                        totalRows: 0,
                        dataList: []
                    }
                },
                searchColumns: [],
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: false,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$t('名称'),
                        key: 'instanceName',
                        sortKey: 'instance_name',
                        columnShow: true,
                        disabledSearch: false,
                        sortable: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('p', {
                                class: ''
                            }, [
                                params.row.lockStatus === 'locked' &&
                                h('span', {
                                    attrs: {
                                        title: `${this.$i18n.t('已被')}${params.row.lockUserEmail}${this.$i18n.t('锁定')}`
                                    }
                                }, [
                                    h('Icon', {
                                        props: {
                                            type: 'ios-lock'
                                        },
                                        style: {
                                            color: '#d67520'
                                        }
                                    })
                                ]),
                                h('a', {
                                    class: {
                                        'tbl-operate': true,
                                        'rc-ellipsis': true
                                    },
                                    style: {
                                        'max-width': 'calc(100% - 16px)',
                                        display: 'inline-block',
                                        'vertical-align': 'middle'
                                    },
                                    attrs: {
                                        title: params.row.instanceName
                                    },
                                    on: { click: () => this.toHostDetail(params.row) }
                                }, params.row.instanceName),
                                h('Tooltip',
                                    {
                                        props: {
                                            content: params.row.osName,
                                            transfer: true,
                                            theme: 'light'
                                        },
                                        style: {
                                            display: params.row.osName && (params.row.osName.toLowerCase().indexOf('centos') > -1 || params.row.osName.toLowerCase().indexOf('redhat') > -1 || params.row.osName.toLowerCase().indexOf('ubuntu') > -1 || params.row.osName.toLowerCase().indexOf('windows') > -1) ? 'inline-block' : 'none'
                                        }
                                    },
                                    [
                                        params.row.osName && h('i', {
                                            class: {
                                                'ecs-icon-os-centos  ecslist-icon-os': params.row.osName.toLowerCase().indexOf('centos') > -1,
                                                'ecs-icon-os-ubuntu  ecslist-icon-os': params.row.osName.toLowerCase().indexOf('ubuntu') > -1,
                                                'ecs-icon-os-redhat  ecslist-icon-os': params.row.osName.toLowerCase().indexOf('redhat') > -1,
                                                'env-icon window-icon': params.row.osName.toLowerCase().indexOf('windows') > -1
                                            }
                                        })
                                    ]
                                )
                            ])
                        }
                    },
                    {
                        key: 'envId',
                        title: this.$i18n.t('云环境'),
                        columnShow: true,
                        sortKey: 'cloudEnvType',
                        sortable: true,
                        columnsChoosed: true,
                        disabledSearch: this.quote !== 'host',
                        searchType: 'select',
                        searchData: [],
                        searchFilterValues: ['all'], // 只适用于下拉搜索，当有searchFilterValues时，会过滤数组里面的搜索值
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                                h('i', { style: 'vertical-align: middle;', class: this.envIcon(params.row.cloudEnvType) }),
                                h('span', { style: 'vertical-align: middle;', class: 'icon-text' }, params.row.cloudEnvName)
                            ])
                        }
                    },
                    {
                        title: this.$i18n.t('实例类型'),
                        key: 'cpu',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        render: (h, params) => {
                            const s = `CPU:${params.row.cpu || 0}${this.$t('核')}、${this.$t('内存')}:${params.row.memory ? (params.row.memory / 1024).toFixed(2) : 0}GB`
                            return h('span', {
                                class: 'rc-ellipsis',
                                attrs: {
                                    title: s
                                }
                            }, s)
                        }
                    },
                    {
                        title: this.$i18n.t('IP地址'),
                        key: 'ipLike',
                        columnShow: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            let s = ''
                            if (params.row.publicIp && params.row.innerIp) {
                                s = `(公)${params.row.publicIp},(内)${params.row.innerIp}`
                            } else if (params.row.publicIp) {
                                s = `(公)${params.row.publicIp}`
                            } else if (params.row.innerIp) {
                                s = `(内)${params.row.innerIp}`
                            }
                            return h('div', {
                                class: 'rc-ellipsis',
                                attrs: {
                                    title: s
                                }
                            }, [
                                h('span', { style: params.row.publicIp ? '' : 'display: none' }, '(公)' + params.row.publicIp + ' '),
                                h('span', { style: params.row.innerIp ? '' : 'display: none' }, '(内)' + params.row.innerIp)
                            ])
                        }
                    },
                    {
                        title: this.$t('登陆方式'),
                        key: 'remoteLoginType',
                        className: 'ellipsis',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            const str = params.row.remoteLoginType === 'ByPassword' ? '密码登录'
                                : params.row.remoteLoginType === 'ByKeypair' ? '密钥登录' : '--'
                            return h('span', { attrs: { title: str } }, str)
                        }
                    },
                    {
                        title: this.$t('状态'),
                        key: 'status',
                        // 去掉容器和镜像宽度减少70
                        width: this.$store.state.app.appConfig.language ? 210 : 180,
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        searchType: 'select',
                        searchData: [],
                        searchFilterValues: ['all'], // 只适用于下拉搜索，当有searchFilterValues时，会过滤数组里面的搜索值
                        renderHeader: (h, params) => {
                            return h('div', { style: { display: 'inline-block' } },
                                [
                                    h('span', this.$t('状态')),
                                    h('Tooltip', {
                                        props: { transfer: true, placement: 'right', theme: 'light' }
                                    }, [h('i', {
                                        class: {
                                            'icon-prompt-1-o': true,
                                            'tips-style': true
                                        },
                                        style: {
                                            'font-size': '12px',
                                            'padding-right': '5px'
                                        }
                                    }),
                                    h('div', { slot: 'content' }, [
                                        h('p', this.$t('创建失败的状态点击可查看详情'))])]
                                    )
                                ])
                        },
                        render: (h, params) => {
                            params.row.sshPort && (params.row.sshPort += '')
                            return h('instancestatus', {
                                class: 'rc-ellipsis',
                                props: {
                                    row: params.row,
                                    isNoPer: true,
                                    quote: this.quote
                                },
                                on: {
                                    refresh: () => {
                                        this.refresh()
                                    },
                                    viewTaskLog: () => {
                                        this.viewTaskLog(params.row)
                                    },
                                    viewNodeMonitor: () => {
                                        this.viewNodeMonitor(params.row)
                                    }
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('操作'),
                        // width: 190,
                        width: this.$store.state.app.appConfig.language ? 200 : 170,
                        columnShow: true,
                        columnsChoosed: true,
                        tooltip: false,
                        render: (h, params) => {
                            return h('div', { class: 'tbl-btn-div' }, [
                                h('a', { class: { disabled: this.checkBtnStatus('start', params.row) }, on: { click: () => this.instanceAction('start', params.row) } }, this.$t('启动')),
                                h('a', { class: { disabled: this.checkBtnStatus('restart', params.row) }, on: { click: () => this.instanceAction('restart', params.row) } }, this.$t('重启')),
                                h('a', { class: { disabled: this.checkBtnStatus('stop', params.row) }, on: { click: () => this.instanceAction('stop', params.row) } }, this.$t('停止'))
                            ])
                        }
                    }
                ]
            },
            isBssAdmin: isBssAdmin,
            logModal: false,
            logLoading: false,
            logs: [],
            monitorModal: false
        }
    },
    created () {
        this.init()
    },
    methods: {
        init () {
            if (this.isBssAdmin) {
                this.tableAttr.columns.splice(this.tableAttr.columns.length - 1, 1)
            }
        },
        refresh () { }
    }
}
</script>
